import DistributionWidget from './components/DistributionWidget';
import SmileysWidget from './components/SmileysWidget';
import SmileysGaugeDistributionWidget from './components/SmileysGaugeDistributionWidget';
import NpsWidget from './components/NpsWidget';
import NpsGaugeDistributionWidget from './components/NpsGaugeDistributionWidget';
import CommentsWidget from './components/CommentsWidget';
import DistributionByDateWidget from './components/DistributionByDateWidget';
import CountByDeviceWidget from './components/CountByDeviceWidget';
import ScoreByDeviceWidget from './components/ScoreByDeviceWidget';
import ScoreByDeviceTagWidget from './components/ScoreByDeviceTagWidget';
import NpsByDeviceWidget from './components/NpsByDeviceWidget';
import ScoreByDeviceAndDateWidget from './components/ScoreByDeviceAndDateWidget';
import ScoreByDayOfWeekWidget from './components/ScoreByDayOfWeekWidget';
import NpsByDayOfWeekWidget from './components/NpsByDayOfWeekWidget';
import ScoreByHourOfDayWidget from './components/ScoreByHourOfDayWidget';
import NpsByHourOfDayWidget from './components/NpsByHourOfDayWidget';
import ScoreByAnswerToOtherQuestionWidget from './components/ScoreByAnswerToOtherQuestionWidget';
import NpsByAnswerToOtherQuestionWidget from './components/NpsByAnswerToOtherQuestionWidget';
import WordCloudWidget from './components/WordCloudWidget';
import MunicipalitiesWidget from './components/MunicipalitiesWidget';
import CountriesWidget from './components/CountriesWidget';
import PageBreakWidget from './components/PageBreakWidget';
import NpsByDeviceTagWidget from './components/NpsByDeviceTagWidget';
import SmileysCsatWidget from './components/SmileysCsatWidget';
import CsatByDeviceWidget from './components/CsatByDeviceWidget';
import CsatByDeviceTagWidget from './components/CsatByDeviceTagWidget';
import CsatByDeviceAndDateWidget from './components/CsatByDeviceAndDateWidget';
import CsatByDayOfWeekWidget from './components/CsatByDayOfWeekWidget';
import CsatByHourOfDayWidget from './components/CsatByHourOfDayWidget';
import CsatByAnswerToOtherQuestionWidget from './components/CsatByAnswerToOtherQuestionWidget';



export default [
  { id: 'distribution', name: 'Distribution', component: DistributionWidget },
  { id: 'smileys', name: 'Smiley question', component: SmileysWidget },
  { id: 'smileys-csat', name: 'Smiley CSAT', component: SmileysCsatWidget },
  { id: 'smileys-gauge-distribution', name: 'Smiley question (no line chart)', component: SmileysGaugeDistributionWidget },
  { id: 'nps', name: 'NPS question', component: NpsWidget },
  { id: 'nps-gauge-distribution', name: 'NPS question (no line chart)', component: NpsGaugeDistributionWidget },
  { id: 'comments', name: 'Comments', component: CommentsWidget },
  { id: 'distribution-by-date', name: 'Distribution by date', component: DistributionByDateWidget },
  { id: 'count-by-device', name: 'Count by device', component: CountByDeviceWidget },
  { id: 'score-by-device-tag', name: 'Score by device tag', component: ScoreByDeviceTagWidget },
  { id: 'nps-by-device-tag', name: 'NPS by device tag', component: NpsByDeviceTagWidget },
  { id: 'score-by-device', name: 'Score by device', component: ScoreByDeviceWidget },
  { id: 'nps-by-device', name: 'NPS by device', component: NpsByDeviceWidget },
  { id: 'score-by-device-and-date', name: 'Score by device and date', component: ScoreByDeviceAndDateWidget },
  { id: 'score-by-day-of-week', name: 'Score by day of week', component: ScoreByDayOfWeekWidget },
  { id: 'nps-by-day-of-week', name: 'NPS by day of week', component: NpsByDayOfWeekWidget },
  { id: 'score-by-hour-of-day', name: 'Score by hour of day', component: ScoreByHourOfDayWidget },
  { id: 'nps-by-hour-of-day', name: 'NPS by hour of day', component: NpsByHourOfDayWidget },
  { id: 'score-by-answer-to-other-question', name: 'Score by answer to other question', component: ScoreByAnswerToOtherQuestionWidget },
  { id: 'nps-by-answer-to-other-question', name: 'NPS by answer to other question', component: NpsByAnswerToOtherQuestionWidget },
  { id: 'word-cloud', name: 'Word cloud', component: WordCloudWidget },
  { id: 'municipalities', name: 'Municipalities', component: MunicipalitiesWidget },
  { id: 'countries', name: 'Countries', component: CountriesWidget },
  { id: 'page-break', name: 'Page break', component: PageBreakWidget },
  { id: 'csat-by-device', name: 'CSAT by device', component: CsatByDeviceWidget },
  { id: 'csat-by-device-tag', name: 'CSAT by device tag', component: CsatByDeviceTagWidget },
  { id: 'csat-by-device-and-date', name: 'CSAT by device and date', component: CsatByDeviceAndDateWidget },
  { id: 'csat-by-day-of-week', name: 'CSAT by day of week', component: CsatByDayOfWeekWidget },
  { id: 'csat-by-hour-of-day', name: 'CSAT by hour of day', component: CsatByHourOfDayWidget },
  { id: 'csat-by-answer-to-other-question', name: 'CSAT by answer to other question', component: CsatByAnswerToOtherQuestionWidget },

];



// WEBPACK FOOTER //
// ./src/components/widgetTypes/widgetTypes.js